module.exports = __webpack_public_path__ + "img/lock-black.aa0ed875.svg";